import React from 'react'
import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { FaShieldAlt, FaChartLine, FaTruck, FaBullhorn, FaArrowRight, FaThLarge } from 'react-icons/fa'

// Home-page seller CTA — compact conversion block.
//   "Satıcı kimi başla" → /satici-ol (real application)
//   "Paneli gör" / "Demoya bax" → /seller-hub (public panel demo)
const BENEFITS = [
    { icon: <FaShieldAlt />, labelKey: 'home.becomeSeller.benefits.secure' },
    { icon: <FaChartLine />, labelKey: 'home.becomeSeller.benefits.panel' },
    { icon: <FaTruck />,     labelKey: 'home.becomeSeller.benefits.delivery' },
    { icon: <FaBullhorn />,  labelKey: 'home.becomeSeller.benefits.promo' },
]

const BecomeSellerCTA = () => {
    const { t } = useTranslation()
    return (
        <section className='w-full max-w-marketplace mx-auto px-4 sm:px-4 md-lg:px-5 md:px-5 lg:px-8 mt-2 mb-6'>
            <div className='relative overflow-hidden rounded-3xl border border-brand-100 bg-gradient-to-br from-brand-50 via-white to-accent-50/40 p-6 shadow-card sm:p-5'>
                <div className='pointer-events-none absolute -right-16 -top-20 h-56 w-56 rounded-full bg-brand-200/30 blur-3xl' aria-hidden='true' />
                <div className='relative flex items-center gap-6 md-lg:flex-col md-lg:items-stretch'>
                    {/* Copy + buttons */}
                    <div className='min-w-0 flex-1 md-lg:w-full'>
                        <span className='inline-flex items-center gap-1.5 rounded-pill bg-brand-100 px-3 py-1 text-[10px] font-bold uppercase tracking-wider text-brand-700'>
                            {t('home.becomeSeller.badge')}
                        </span>
                        <h2 className='mt-2 text-2xl font-black leading-tight text-slate-900 sm:text-xl'>{t('home.becomeSeller.title')}</h2>
                        <p className='mt-1.5 max-w-2xl text-sm text-slate-600'>{t('home.becomeSeller.desc')}</p>

                        <div className='mt-4 grid max-w-xl grid-cols-2 gap-2 sm:grid-cols-1'>
                            {BENEFITS.map((b, i) => (
                                <div key={i} className='inline-flex items-center gap-2 text-sm text-slate-700'>
                                    <span className='inline-flex h-7 w-7 shrink-0 items-center justify-center rounded-card bg-brand-100 text-xs text-brand-700'>{b.icon}</span>
                                    {t(b.labelKey)}
                                </div>
                            ))}
                        </div>

                        <div className='mt-5 flex flex-wrap items-center gap-3 sm:w-full sm:flex-col sm:items-stretch'>
                            <Link
                                to='/satici-ol'
                                className='home-seller-cta-link inline-flex h-11 items-center justify-center gap-2 rounded-card bg-brand-600 px-5 text-sm font-bold text-white shadow-card transition-all hover:-translate-y-0.5 hover:bg-brand-700'
                            >
                                {t('home.becomeSeller.cta')} <FaArrowRight size={12} />
                            </Link>
                            <Link
                                to='/seller-hub'
                                className='home-seller-cta-link inline-flex h-11 items-center justify-center gap-2 rounded-card border border-brand-200 bg-white px-5 text-sm font-bold text-brand-700 transition-all hover:border-brand-400 hover:-translate-y-0.5'
                            >
                                {t('home.becomeSeller.ctaPanel')}
                            </Link>
                        </div>
                    </div>

                    {/* Clean demo-promo card (no fake stats) */}
                    <div className='w-72 shrink-0 rounded-2xl border border-brand-100 bg-white p-5 text-left shadow-sm md-lg:w-full md-lg:text-center'>
                        <span className='mx-0 inline-flex h-11 w-11 items-center justify-center rounded-2xl bg-gradient-to-br from-brand-500 to-indigo-600 text-lg text-white shadow md-lg:mx-auto'>
                            <FaThLarge />
                        </span>
                        <h3 className='mt-3 text-sm font-black text-slate-900'>{t('home.becomeSeller.demoCardTitle')}</h3>
                        <p className='mt-1 text-[13px] leading-relaxed text-slate-500'>{t('home.becomeSeller.demoCardText')}</p>
                        <Link
                            to='/seller-hub'
                            className='home-seller-cta-link mt-4 inline-flex h-10 items-center justify-center gap-2 rounded-card bg-gradient-to-r from-brand-600 to-indigo-600 px-5 text-sm font-bold text-white shadow-sm transition-transform hover:-translate-y-0.5'
                        >
                            {t('home.becomeSeller.demoCardBtn')} <FaArrowRight size={12} />
                        </Link>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default BecomeSellerCTA
